<template>
  <div v-if="message"
       class="auth">
    <BaseAlertInline :value="message" class="_success"/>
    <div class="auth__buttons">
      <button @click.prevent="onOk"
              class="auth__btn base-btn">
        Ok
      </button>
    </div>
  </div>
  <div v-else
       @keypress.enter="onResetPassword"
       class="auth">
    <BaseInput type="email"
               v-model="inputs.email.value"
               :error="inputs.email.error"
               placeholder="Email"
               class="auth__input"
    />
    <BaseAlertInline :value="overallErrorsMix" class="_warning"/>

    <div class="auth__buttons">
      <button @click.prevent="onResetPassword"
              class="auth__btn base-btn">
        {{$t("Змінити пароль")}}
      </button>
    </div>
  </div>
</template>

<script>
  import formMixins from '../mixins/formMixins'

  export default {
    mixins: [formMixins],
    data() {
      return {
        inputs: {
          email: {
            value: null
          }
        },
        message: null
      }
    },
    methods: {
      onResetPassword() {
        this.resetErrorsMix(this.inputs)

        this.$store.dispatch('user/resetPassword', this.createSendDataMix(this.inputs)).then((data) => {
          this.message = data.message
        }).catch(e => {
          this.handlerErrorMix(e, this.inputs)
        })
      },
      onOk() {
        this.$vModal.close('auth-reset-password')
      }
    }
  }
</script>

<style lang="less">

</style>
